export default __webpack_public_path__ + "static/dca-20ed391f3147d178d049eaeb3d24191d.jpg";